import { NgModule } from '@angular/core';

import { HeaderComponent } from './header.component';
import { SupportInfoComponent } from './support-info/support-info.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '@shared/shared.module';
import { HeaderLanguagesComponent } from './header-languages/header-languages.component';
import { AffiliateSelectionModalComponent } from '../affiliate-selection-modal/affiliate-selection-modal.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [SharedModule, BsDropdownModule, ReactiveFormsModule],
  declarations: [HeaderComponent, SupportInfoComponent, HeaderLanguagesComponent, AffiliateSelectionModalComponent],
  exports: [HeaderComponent, AffiliateSelectionModalComponent]
})
export class HeaderModule {}
